export const environment = {
    production: false,
    apiUrl: 'https://uatapi.carevance.solutions',
    onboardingUrl: 'https://onboardingapiuat.carevance.solutions',
    commonLookupUrl: 'https://commonapiuat.carevance.solutions',
    twilioUrl: 'https://twilioapiuat.carevance.solutions',
    demoUrl: 'https://demoapiuat.carevance.solutions',
    careManagerPortalUrl: 'https://caremanagerapiuat.carevance.solutions',
    microserviceurl:'https://servicemanagementdevapi.carevance.solutions',
    logisticUrl: 'https://logisticsapiuat.carevance.solutions',
    ragUrl: 'https://rag-chat-api.carevance.solutions',
    demoNew:'https://auto-calls.carevance.solutions',
  doctorUrl: 'https://doctorapiuat.carevance.solutions',

  };